export var ToggleVariant;
(function (ToggleVariant) {
    ToggleVariant["Invert"] = "invert";
    ToggleVariant["Normal"] = "normal";
})(ToggleVariant || (ToggleVariant = {}));
